module.exports = __webpack_public_path__ + "img/CR06EU.78248e33.png";